import { getTimeStamp } from "utils/time-stamp";
import { api } from "../api";
import { ENDPOINTS } from "../constants";

const postUserEvent = (eventCode, userId, orgId, formRunGuid) => {
    const payload = {
        date: getTimeStamp(),
        triggerUserID: userId,
        orgID: orgId,
        eventCode: eventCode,
        formRunGUID: formRunGuid,
    };
    return api.post(ENDPOINTS.USER_EVENT, payload);
};

export { postUserEvent };
